import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { COLUMN_ORDER, columnLabelKey } from '../detail/gantt-columns'
import type { ColumnId } from '../lib/constants'

/** Columns that always print: without the row number and the name a row cannot be told apart. */
export const ALWAYS_PRINT_COLUMNS: ColumnId[] = ['rowNumber', 'name']

interface Props {
  selected: ColumnId[]
  onToggle: (id: ColumnId, checked: boolean) => void
  disabled?: boolean
}

/** Two-column checkbox grid of the grid's columns, in the Gantt's own order. The selection is
 * seeded from what the screen shows and lives only for this dialog — it is not persisted. */
const PrintColumnsPicker: React.FC<Props> = ({ selected, onToggle, disabled = false }) => {
  const { t } = useTranslation()
  return (
    <div className="space-y-1">
      <div className="text-xs text-muted-foreground">{t('Schedule_print_columns')}</div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-1">
        {COLUMN_ORDER.map((c) => {
          const locked = ALWAYS_PRINT_COLUMNS.indexOf(c) >= 0
          const id = `print-col-${c}`
          return (
            <div key={c} className="flex items-center gap-2">
              <Checkbox
                id={id}
                checked={selected.indexOf(c) >= 0}
                disabled={disabled || locked}
                onCheckedChange={(checked) => onToggle(c, checked === true)}
              />
              <Label htmlFor={id} className="text-sm font-normal">{t(columnLabelKey[c])}</Label>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PrintColumnsPicker
